/* eslint-disable react/prop-types */
import { Link } from 'react-router-dom';

const MobileNav = ({ isOpen, onClose }) => {
   const scrollToSection = (sectionId) => {
      const element = document.getElementById(sectionId);
      if (element) {
         // Scroll the element into view with smooth behavior
         element.scrollIntoView({
            behavior: 'smooth',
            block: 'start' // Align to the top of the viewport
         });

         // After smooth scroll, immediately adjust for the navbar
         setTimeout(() => {
            const offset = 80; // Adjust this value according to the height of your navbar
            const elementPosition = element.getBoundingClientRect().top;
            const offsetPosition = elementPosition + window.pageYOffset - offset;

            window.scrollTo({
               top: offsetPosition,
               behavior: 'smooth'
            });
         }, 300); // Delay for smooth scroll to complete before adjusting
      }
   };

   return (
      <div
         className={`fixed top-20 left-0 h-full w-full bg-gray-900 text-white transform ${
            isOpen ? 'translate-x-0' : '-translate-x-full'
         } transition-transform duration-300 ease-in-out z-30`}
      >
         <button onClick={onClose} className="absolute top-4 right-4 text-white text-2xl focus:outline-none">
            &times;
         </button>
         <ul className="flex flex-col items-center mt-10 space-y-6">
            <li>
               <Link
                  onClick={() => {
                     scrollToSection('about');
                     onClose(); // Close the navbar when clicked
                  }}
                  className="text-lg"
               >
                  ABOUT ME
               </Link>
            </li>
            <li>
               <Link
                  onClick={() => {
                     scrollToSection('services');
                     onClose(); // Close the navbar when clicked
                  }}
                  className="text-lg"
               >
                  SERVICES
               </Link>
            </li>
            <li>
               <Link
                  onClick={() => {
                     scrollToSection('skills');
                     onClose(); // Close the navbar when clicked
                  }}
                  className="text-lg"
               >
                  SKILLS
               </Link>
            </li>
            <li>
               <Link
                  onClick={() => {
                     scrollToSection('contact');
                     onClose(); // Close the navbar when clicked
                  }}
                  className="text-lg"
               >
                  CONTACT
               </Link>
            </li>
         </ul>
      </div>
   );
};

export default MobileNav;
